import React from 'react';

type View3DControlsGridProps = {
  children: React.ReactNode;
};

/**
 * Dense two-by-two grid for 3D property fields (floor distance, rotations).
 * Avoids lonely half-width rows that leave empty space on the right.
 */
const View3DControlsGrid: React.FC<View3DControlsGridProps> = ({ children }) => (
  <div className="grid w-full grid-cols-2 items-end gap-x-2 gap-y-1.5 py-1">
    {children}
  </div>
);

export default View3DControlsGrid;
